import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from 'src/environments/environment';
import { getTranslationProvider } from '../core/i18n/getTranslationProvider';
import { AuthActions } from '../core/state/auth/auth.actions';
import { BlFrontendButtonComponent } from '../core/wrappers/bl-frontend-button.component';
import { BlFrontendIconComponent } from '../core/wrappers/bl-frontend-icon.component';
import { LoginPageComponent } from './login-page.component';

@Component({
  selector: 'app-sso-login',
  standalone: true,
  imports: [RouterLink, TranslocoModule, BlFrontendButtonComponent, BlFrontendIconComponent],
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.css'],
  providers: [getTranslationProvider('SsoLoginComponent')],
})
export class SsoLoginComponent extends LoginPageComponent {
  protected readonly showLegacyLoginTestLink = !environment.production;

  onContinueToLogin(): void {
    this.store.dispatch(AuthActions.initSsoLogin({ useBlAccountAuthenticator: false }));
  }

  onCreateAccount(): void {
    // Implement the logic to create a new account
  }
}
